module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-1-white-4f0ef77155bf5b7d3a954edc5ad56815.svg";